import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Concept from "@/components/landing/Concept";
import Marquee from "@/components/landing/Marquee";
import Menu from "@/components/landing/Menu";
import Wine from "@/components/landing/Wine";
import Eccellenze from "@/components/landing/Eccellenze";
import Events from "@/components/landing/Events";
import Ambiente from "@/components/landing/Ambiente";
import Gallery from "@/components/landing/Gallery";
import Location from "@/components/landing/Location";
import Reviews from "@/components/landing/Reviews";
import Reservation, { StickyWhatsApp } from "@/components/landing/Reservation";
import Footer from "@/components/landing/Footer";
import CookieBanner from "@/components/landing/CookieBanner";
import PrivacyPolicy from "@/components/landing/PrivacyPolicy";
import Visite from "@/components/landing/Visite";
import { trackEvent } from "@/data/content";

const trackVisit = () => {
  if (sessionStorage.getItem("jt-tracked")) return;
  sessionStorage.setItem("jt-tracked", "1");
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ref: document.referrer || "",
      ua: navigator.userAgent,
      lang: navigator.language || "",
    }),
  }).catch(() => {});
};

const Landing = () => {
  useEffect(() => {
    trackVisit();
    let viewTimer;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !sessionStorage.getItem("jt-pv")) {
            viewTimer = setTimeout(() => {
              sessionStorage.setItem("jt-pv", "1");
              trackEvent("prenota_view");
            }, 2500);
          } else if (!entry.isIntersecting) {
            clearTimeout(viewTimer);
          }
        });
      },
      { threshold: 0.4 }
    );
    const prenotaEl = document.querySelector("#prenota");
    if (prenotaEl) observer.observe(prenotaEl);
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      observer.disconnect();
      clearTimeout(viewTimer);
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#0D0C0B] text-[#F7F4EE] antialiased overflow-x-clip">
      <Header />
      <main>
        <Hero />
        <Concept />
        <Marquee />
        <Menu />
        <Wine />
        <Eccellenze />
        <Events />
        <Ambiente />
        <Gallery />
        <Location />
        <Reviews />
        <Reservation />
      </main>
      <Footer />
      <StickyWhatsApp />
      <CookieBanner />
      <PrivacyPolicy />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/visite" element={<Visite />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
